import React, { Fragment, useEffect, useState } from "react";
import ProductServices from '../../../services/product-services';
import useMobile from "../../../shared/hooks/useMobile";
import { localStorage } from '../../../shared/utils/storage';
import CardProduct from "../../atoms/card-product/card-product";
import GuidelineProducts from "../../atoms/guideline-products/guideline-products";
import './list-products.scss';

const ListProducts = ({ products, guideline, setActiveShoppingModal }) => {
    let guidelineShow = true
    const mobile = useMobile();

    const [allProductsRating, setAllProductsRating] = useState(null)

    useEffect(() => {
        getRating()
    }, []);

    function getRating() {
        const tokenInfo = localStorage.getItem("TOKEN_INFO") ? localStorage.getItem("TOKEN_INFO") : null
        let config = {
            headers: {
                Authorization: tokenInfo ? tokenInfo.idToken : null,
            },
        }
        const payload = process.env.COUNTRY_CODE

        ProductServices.allRateProduct(tokenInfo ? config : null, payload).then(
            response => {
                if (response.status === 200) {
                    setAllProductsRating(response.data ? response.data : null)
                } else {
                    setAllProductsRating(null)
                }
            }
        )

    }

    return (
        <div className="f-m-list-product">
            {products && products.map(
                (product, index) => {
                    function filterById(obj) {
                        if (obj.productId === product.idDelProducto) {
                            return true
                        }
                    }
                    const productRating = allProductsRating && allProductsRating.filter(filterById).filter(Boolean)

                    if (index == 9 && !mobile) {
                        guidelineShow = false;
                        return <Fragment key={index} >
                            <div className="f-m-list-product__guideline">
                                <GuidelineProducts guideline={guideline} />
                            </div>
                            <CardProduct product={product}
                                productRating={productRating !== null && (productRating[0])}
                                setActiveShoppingModal={setActiveShoppingModal}
                            />
                        </Fragment>
                    }
                    return <CardProduct key={index} product={product} setActiveShoppingModal={setActiveShoppingModal} />
                }
            )}
            {guidelineShow && <GuidelineProducts guideline={guideline} />}
        </div>
    )

}

export default ListProducts